// Autogenerated file
export const scenarioQuestionTypesEnum = {
    SelectOne: "SelectOne",
    SelectMultiple: "SelectMultiple",
    Instruction: "Instruction",
    Value: "Value",
};
export const scenarioQuestionTypes = [
    { label: "Одно из значений", value: "SelectOne" },
    { label: "Несколько из значений", value: "SelectMultiple" },
    { label: "Информационный текст", value: "Instruction" },
    { label: "Произвольное значение", value: "Value" },
];
